<template>
  <div
    class="d-flex justify-content-center align-items-center gap-2 p-2 border rounded"
    role="button"
    @click="copyApiId()"
  >
    <span class="api-id">{{ rowData.apiId.slice(0, 20) }}...</span>
    <i class="fa fa-clipboard" aria-hidden="true"></i>
  </div>
</template>

<script>
export default {
  name: 'apiId',
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  methods: {
    copyApiId() {
      this.copyToClipboard(this.rowData.apiId)
    }
  }
}
</script>
<style lang="scss" scoped>
.gap-2 {
  gap: 0.5rem;
}
.api-id {
  overflow-wrap: anywhere;
}
</style>
